import React from 'react';
import { formatDate, formatTime } from '../../utils/helpers';

const DateTimeDisplay = ({ dateStr }) => {
   if (!dateStr) return <span className="text-gray-400 dark:text-gray-500">—</span>;
   return (
      <span>
         <span className="block">{formatDate(dateStr)}</span>
         <span className="block text-xs text-gray-400 dark:text-gray-500 mt-0.5">
            {formatTime(dateStr)}
         </span>
      </span>
   );
};

export default DateTimeDisplay;
